import { useEffect,  useRef } from "react";
import { Outlet } from 'react-router-dom';
import { Helmet, HelmetProvider  } from "react-helmet-async";





const PlannerLayout = () => {
 

  return (
    <HelmetProvider>
    <Helmet>

    
      </Helmet>

 
        <Outlet />
   
      </HelmetProvider>
    )
  }
  
  export default PlannerLayout;